export const features = [
	'wifi',
	'coffee',
	'water',
	'restroom',
	'disabled_access',
	'elevator',
	'tv',
	'video_projector',
	'video_conferencing',
	'paperboard',
	'air_conditioning',
	'whiteboard',
	'sound_system',
	'hdmi_adapter',
]
